"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var immutable_1 = require("immutable");
var of_1 = require("rxjs/observable/of");
var ModuleLoadingService = /** @class */ (function () {
    function ModuleLoadingService(paths, summaryPaths) {
        if (summaryPaths === void 0) { summaryPaths = {}; }
        this.pathMap = immutable_1.Map(paths);
        this.summaryMap = immutable_1.Map(summaryPaths);
    }
    ModuleLoadingService.prototype.loadModule = function (modulePath) {
        if (this.pathMap.has(modulePath)) {
            // }
            return this.pathMap.get(modulePath)();
        }
        else {
            throw new TypeError("Dependency for path " + modulePath + " is not defined");
        }
    };
    ModuleLoadingService.prototype.loadSummariesIfAvailable = function (modulePath) {
        if (this.summaryMap.has(modulePath)) {
            return this.summaryMap.get(modulePath).map(function (f) { return f(); });
        }
        else {
            return [];
        }
    };
    ModuleLoadingService.prototype.availableModules = function () {
        return of_1.of(this.pathMap.keySeq());
    };
    ModuleLoadingService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [Object, Object])
    ], ModuleLoadingService);
    return ModuleLoadingService;
}());
exports.ModuleLoadingService = ModuleLoadingService;
//# sourceMappingURL=module-loading.service.js.map